/**
 * 基础信息，即全项目通用，不和业务相关
 */

export const useBaseInfoStore = defineStore('base-info', {
  state: () => {
    return {
      vueLayout: null,
      serverClientTimeDiff: null,
      latestServerTime: null,
      globalDataDic: null,
      globalDataDicUnLogged: null,
      regionData: null,
      menuType: null,
      personalCenterOperateType: 1, // 个人中心操作类型操作类型 1：员工信息，2：账号信息，3：修改密码，4：扫码关注，5：其他设置
      mobileTransitionAnim: true,
      mobileWorkflowActiveTab: 'plus',
    };
  },
  actions: {
    /**
     * 设置服务器时间
     *
     * @param serverTime 服务器时间
     * @returns 无返回值
     */
    setServerTime(serverTime) {
      this.latestServerTime = serverTime;
    },
    /**
     * 设置时间差
     *
     * @param timeDiff 时间差
     * @returns 无返回值
     */
    setTimeDiff(timeDiff) {
      this.serverClientTimeDiff = timeDiff;
    },
    /**
     * 设置服务器全局参数
     *
     * @param globalParams 全局参数对象
     */
    setServerGlobalParams(globalParams) {
      this.globalDataDic = globalParams;
    },

    /**
     * 设置服务器全局参数(未登录)
     *
     * @param globalParams 全局参数对象
     */
    setServerGlobalParamsUnLogged(globalParams) {
      this.globalDataDicUnLogged = globalParams;
    },

    /**
     * 设置Vue布局
     *
     * @param layout Vue布局对象
     */
    setVueLayout(layout) {
      this.vueLayout = layout;
    },
    /**
     * 设置菜单类型
     *
     * @param type 菜单类型
     * @returns 无返回值
     */
    setMenuType(type) {
      this.menuType = type;
    },
    /**
     * 设置区域数据
     *
     * @param data 区域数据
     * @returns 无
     */
    setRegionData(data) {
      this.regionData = data;
    },
    /**
     * 设置个人中心操作类型
     *
     * @param operateType 操作类型
     * @returns 无返回值
     */
    setPersonalCenterOperateType(operateType) {
      this.personalCenterOperateType = operateType;
    },
    /**
     * 设置移动端页面切换动画
     *
     * @param {Boolean} data 是否开启页面切换动画
     */
    isMobileTransitionAnim(data) {
      this.mobileTransitionAnim = data;
    },
    /**
     * 设置移动端业务流程选中Tab
     *
     * @param {String} activeName 选中Tab的name
     */
    setMobileWorkflowActiveTab(activeName) {
      this.mobileWorkflowActiveTab = activeName;
    },

    getUserTypeList() {
      if (this.globalDataDic?.userTypeList) {
        if (
          this.globalDataDic?.userTypeList.filter((f) => f.id === 0).length ===
          0
        ) {
          this.globalDataDic?.userTypeList.push({
            id: 0,
            userTypeName: '不限',
          });
        }

        const userTypeList = this.globalDataDic?.userTypeList.map((m) => {
          return {
            label: m.userTypeName,
            value: m.id,
          };
        });
        return userTypeList;
      }
      return [];
    },

    getUserTypeName(id) {
      if (this.globalDataDic?.userTypeList) {
        if (
          this.globalDataDic?.userTypeList.filter((f) => f.id === 0).length ===
          0
        ) {
          this.globalDataDic?.userTypeList.push({
            id: 0,
            userTypeName: '不限',
          });
        }
        return this.globalDataDic?.userTypeList.find((m) => m.id === id)
          ?.userTypeName;
      }
      return null;
    },

    getSipAppId() {
      return this.globalDataDicUnLogged?.appId;
    },
  },
});
